export default __webpack_public_path__ + "static/media/landingPage-mobile.02981699.jpg";